import(/* webpackMode: "eager" */ "/app/src/app/(external-pages)/contact/ContactSplit.tsx")